import { requireEl } from './dom';

export type CommentItem = {
  id: number;
  author?: string;
  is_op?: boolean;
  body: string;
  created_at: number;
};

const COMMENT_AUTHOR = 'Аноним';

function formatAuthor(item: CommentItem): string {
  const name = item.author ?? COMMENT_AUTHOR;
  return item.is_op ? `${name} (OP)` : name;
}

let activePublicId: string | null = null;
let formBound = false;

function formatCommentDate(ts: number): string {
  return new Date(ts * 1000).toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

async function loadComments(publicId: string): Promise<void> {
  const list = requireEl<HTMLElement>('comments-list');
  list.textContent = 'загрузка…';
  try {
    const r = await fetch(`/api/comments?public_id=${encodeURIComponent(publicId)}`);
    if (!r.ok) throw new Error(String(r.status));
    const data = (await r.json()) as { items?: CommentItem[] };
    const items = data.items ?? [];
    list.replaceChildren();
    if (items.length === 0) {
      list.textContent = 'пока нет комментариев — будь первым';
      return;
    }
    for (const item of items) {
      const el = document.createElement('div');
      el.className = 'comment-item';
      const head = document.createElement('div');
      head.className = 'comment-head';
      const author = document.createElement('span');
      author.className = 'comment-author';
      author.textContent = formatAuthor(item);
      const time = document.createElement('time');
      time.dateTime = new Date(item.created_at * 1000).toISOString();
      time.textContent = formatCommentDate(item.created_at);
      const no = document.createElement('span');
      no.className = 'comment-no';
      no.textContent = `No.${item.id}`;
      head.append(author, time, no);
      const body = document.createElement('p');
      body.className = 'comment-body';
      body.textContent = item.body;
      el.append(head, body);
      list.appendChild(el);
    }
  } catch {
    list.textContent = 'не удалось загрузить комментарии';
  }
}

function ensureFormBound(): void {
  if (formBound) return;
  formBound = true;

  const form = requireEl<HTMLFormElement>('comment-form');
  const status = requireEl<HTMLElement>('comment-status');
  const bodyEl = requireEl<HTMLTextAreaElement>('comment-body');

  form.onsubmit = e => {
    e.preventDefault();
    const body = bodyEl.value.trim();
    if (!body || !activePublicId) return;
    status.textContent = 'отправка…';
    void fetch('/api/comment', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ public_id: activePublicId, body }),
    })
      .then(async r => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) {
          throw new Error(typeof data.error === 'string' ? data.error : String(r.status));
        }
        bodyEl.value = '';
        status.textContent = 'отправлено — появится после модерации';
        return loadComments(activePublicId!);
      })
      .catch(err => {
        status.textContent = err instanceof Error ? err.message : 'ошибка';
      });
  };
}

export function bindComments(publicId: string): void {
  activePublicId = publicId;
  ensureFormBound();
  const section = requireEl<HTMLElement>('permalink-comments');
  section.hidden = false;
  requireEl<HTMLElement>('comment-status').textContent = '';
  void loadComments(publicId);
}

export function hideComments(): void {
  activePublicId = null;
  requireEl<HTMLElement>('permalink-comments').hidden = true;
}

/** Показать комментарии к user-фото или скрыть блок. */
export function syncComments(publicId: string | null | undefined): void {
  if (publicId) {
    bindComments(publicId);
  } else {
    hideComments();
  }
}
